// extracted by mini-css-extract-plugin
export default {"root":"Title-root-4d359482fd3a012a66fe197a1072c1b2"};